





























































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { openSelectList } from '@/main/router/routerPath';
import { ModelNv } from '@/modules/ciselnik/noveVozy/modelNv';
import { ModelOv } from '@/modules/ciselnik/ojeteVozy/modelOv';
import { Partner } from '@/modules/kartoteka/partner';

import { store } from '../store/edit';
import { editMutations } from '../store/types';

export default Vue.extend({
	name: 'ZakladniInformace',
	components: {
		ModelOvSelect: ModelOv.components.Select,
		ZakaznikSelect: Partner.components.Select,
	},
	props: {
		storeUri: { type: String, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): any {
			return {
				modelNv: `${this.storeUri}/${editMutations.MODEL_NV_SELECT}`,
				modelOv: `${this.storeUri}/${editMutations.MODEL_OV_SELECT}`,
				prodavajici: `${this.storeUri}/${editMutations.PRODAVAJICI_SELECT}`,
			};
		},
		modelOvFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
	},
	methods: {
		openModelNvGrid() {
			openSelectList(ModelNv.name, {
				filter: {
					VyrobekvozOzn: this.VyrobekvozOzn,
					Typkod: this.Typkod,
					DoplnekMk: this.DoplnekMk,
					ModelRok: this.ModelRok,
				},
				afterRowSelection: ({ row }) => {
					const data = {
						id: row.ID,
						typkod: row.TYPKOD,
						text: row.TEXT,
						xVyrobekvozOzn: row.X_VYROBEKVOZ_OZN,
						pc: row.PC,
						modelRok: row.MODEL_ROK,
						tablpozice: row.TABLPOZICE,
						objem: row.OBJEM,
						palivoPzn: row.PALIVO_PZN,
						vykon: row.VYKON,
						vyrobekvozOzn: row.VYROBEKVOZ_OZN,
					};
					this.$store.commit((this as any).mutationsMappers.modelNv, { data });
				},
			});
		},
	},
});
